import { Model, fields } from '@gasman/smush';

import { NoteField } from '../../common/notes';

const TONE_CHANNEL_DEF = new fields.ListField(
    'channel',
    new fields.StructField('row', [
        new NoteField('note', { linkedSampleField: 'sample' }),
        new fields.IntegerField('sample', { min: 0, max: 15, default: 0 }),
        new fields.IntegerField('command', { min: 0, max: 15, default: 0 }),
        new fields.IntegerField('parameter', { min: 0, max: 255, default: 0 }),
    ]),
    { length: 64 },
);

class Pattern extends Model([
    new fields.IntegerField('length', { min: 8, max: 64, default: 64 }),
    new fields.TupleField(
        'channels',
        [TONE_CHANNEL_DEF, TONE_CHANNEL_DEF, TONE_CHANNEL_DEF],
        {
            getterName: 'getField',
            setterName: 'setField',
            eventName: 'changeField',
        },
    ),
]) {}

export { Pattern };
